module.exports = __webpack_public_path__ + "static/img/banner_4_no_red.4f3dc112.jpg";